module.exports = __webpack_public_path__ + "img/Icon_close.e73172c7.svg";